import React, { useState, useEffect } from 'react';
import { getUnitsOfMeasure } from '../../api/axios';
import DataTable from '../Table/DataTable';
import { useTranslation } from 'react-i18next';
import { Box, Container } from '@mui/material';

const UnitsOfMeasure = () => {
  const { t } = useTranslation('global');

  const [unitsOfMeasure, setUnitsOfMeasure] = useState([]);
  const [loading, setLoading] = useState(true);
  

  const fetchUnitsOfMeasure = async() =>{
    const response = await getUnitsOfMeasure();
    console.log(response);
    setUnitsOfMeasure(response);
    
    setLoading(false);
  };

  useEffect(() => {
    fetchUnitsOfMeasure();
  }, []);

  const columns = [
    { Header: t("list.id"), accessor: 'id' },
    { Header: t("list.name"), accessor: 'name' },
  ];

  if (loading) {
    return <p>{t("list.loading")}</p>;
  }

  return (
    <Container sx={{ mt: 5 }} fullWidth>
      <DataTable initialData={unitsOfMeasure} columns={columns} entityName="units-of-measure" h2={t("list.unitsOfMeasure")} />
    </Container>
  );
};

export default UnitsOfMeasure;
